import { Injectable } from "@angular/core";
import { TaxiPonto } from '@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-ponto.entity';
import { TaxiPontoController } from "app/controllers/mob/taxi-ponto.controller";
import { TaxiPontoListDTO } from '../../model/dtos/mob/taxi-ponto.dto';
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { TaxiPontoSearch } from "./taxi-ponto.search";

@Injectable({
    providedIn: "root",
})

export class TaxiPontoService implements ApiService<TaxiPonto>{
    
    constructor(
        private _taxiPontoController: TaxiPontoController,
        private _loaderService: LoaderService
      ) { }
          
      find(search?: TaxiPontoSearch): Promise<TaxiPonto[]> {
        this._loaderService.show();
        return this._taxiPontoController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
      }
        
      get(cdPonto: number): Promise<TaxiPonto> {
        this._loaderService.show();
        return this._taxiPontoController.get(cdPonto).finally(() => this._loaderService.hide());
      }
    
      save(entity: TaxiPonto): Promise<TaxiPonto> {
        if(!entity.cdPonto)
          return this.create(entity);
        return this.update(entity);
      }
    
      create(entity: TaxiPonto): Promise<TaxiPonto> {
        this._loaderService.show();
        return this._taxiPontoController.create(entity).finally(() => this._loaderService.hide());
      }
    
      update(entity: TaxiPonto): Promise<TaxiPonto> {
        this._loaderService.show();
        return this._taxiPontoController.update(entity).finally(() => this._loaderService.hide());
      }

      findLocais(search?: TaxiPontoSearch): Promise <TaxiPontoListDTO> {
        this._loaderService.show();
        return this._taxiPontoController.findLocais(search && search.getFilters() || null).finally(() => this._loaderService.hide());
      }

      findPontos(search?: TaxiPontoSearch): Promise<TaxiPontoListDTO> {
        this._loaderService.show();
        return this._taxiPontoController.findPontos(search && search.getFilters() || null).finally(() => this._loaderService.hide());
      }
}
